import type { JsonApiResponse, JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormDataDeep } from 'helpers/formData';

export interface AdviceRoomTranscriptionsPostOptions {
  authToken?: string;
  segment: {
    text: string;
    startTime: string | number;
    endTime: string | number;
  };
}

export function adviceRoomTranscriptionsApi(path: string) {
  return {
    path,
    GET: () => api.get<JsonApiResponse>(path),
    getWebsocketURL: () =>
      api.post<JsonApiResponse<{ attributes: { url: string } }>>(
        `${path}/streaming_transcribe_url`
      ),
    POST: (params: AdviceRoomTranscriptionsPostOptions) =>
      api.post<JsonApiResponseSingle>(`${path}/streaming-transcriptions`, {
        data: {
          attributes: mapFormDataDeep(params),
        },
      }),
    mergedTranscription: () => api.get(`${path}/merged-transcription`),
  };
}
